import { HOST_SLUG, WORKSPACE_SLUG } from "./workspace";

const KEY = "fixli_portal_slug";

export function rememberPortalSlug(slug) {
  if (slug) localStorage.setItem(KEY, slug);
}

export function forgetPortalSlug() {
  localStorage.removeItem(KEY);
}

// Absolute path of the door someone should sign in at: this workspace's /<slug>/login, else the remembered one, else /login.
// Use with window.location (or sameWorkspace() + stripWorkspace() before handing it to the router).
export function loginPath() {
  if (HOST_SLUG) return "/login"; // custom domain: the host is the workspace, its door is plain /login
  const slug = WORKSPACE_SLUG || localStorage.getItem(KEY);
  return slug ? `/${slug}/login` : "/login";
}

export function portalUrl(slug) {
  return `${window.location.origin}/${slug}`;
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try { ok = document.execCommand("copy"); } catch { ok = false; }
    ta.remove();
    return ok;
  }
}
